import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '@routes/dashboard/i18n';
import debounce from 'debounce';
import styles from './template.css';
import template from './template';

/**
 * @summary ItemSearchForm
 * @extends {AoflElement}
 */
@customElement('object-search-form')
class ObjectSearchForm extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of ObjectSearchForm.
   */
  constructor() {
    super();
    this.translations = translations;
    this.queryDebounce = debounce((e) => {
      this.sendSearchEvent();
    }, 200);
  }
  /**
   * @readonly
   */
  static is = 'object-search-form';

  @property({type: String})
  placeholder = '';

  @property({type: String, attribute: true})
  searchTerm = '';

  @property({type: String, attribute: true})
  ['reset-text'] = 'Clear';

  @property({type: Boolean, attribute: false})
  ['column-layout'] = false;

  search(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    this.searchTerm = formData.get('search_term');
    this.sendSearchEvent();
  }

  sendSearchEvent() {
    this.dispatchEvent(new CustomEvent('on-search', {
      detail: {
        field: 'name',
        query: this.searchTerm
      },
      composed: true
    }));
  }

  clearSearch() {
    this.searchTerm = '';
    this.sendSearchEvent();
  }

  onInput(e) {
    this.searchTerm = e.target.value;
    this.queryDebounce();
  }

  disconnectedCallback() {
    this.searchTerm = '';
    super.disconnectedCallback();
  }

  focusSearch() {
    this.shadowRoot.getElementById('query').focus();
  }

  /**
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default ObjectSearchForm;
